import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  pressable: { width: '100%', height: '100%' },
})
